
// modal
export const PROCESS_MODAL_VISIBLE = 'PROCESS_MODAL_VISIBLE'
// 非异步状态
export const CHANGE_WORKFLOW_STATE = 'CHANGE_WORKFLOW_STATE'

export function changeModalVisible(bool) {
	return {
		type: PROCESS_MODAL_VISIBLE,
    visible: bool
	}
}

export function changeWorkflowState(payload) {
	return {
		type: CHANGE_WORKFLOW_STATE,
    payload
	};
}

export default changeModalVisible


// WEBPACK FOOTER //
// ./src/action/process/mutations.js